// extracted by mini-css-extract-plugin
export default {"icon-button":"icon-button--NG53i","iconButton":"icon-button--NG53i"};